import type {AppLocale} from 'i18n/locales'
import bg from './faq-content.bg.json'
import de from './faq-content.de.json'
import en from './faq-content.en.json'
import sv from './faq-content.sv.json'
import tr from './faq-content.tr.json'
import type {EventFaqKey} from './eventFaqKeys'

type Entry = {q: string; a: string}

const packs: Record<AppLocale, Record<string, Entry>> = {
  bg: bg as Record<string, Entry>,
  en: en as Record<string, Entry>,
  tr: tr as Record<string, Entry>,
  de: de as Record<string, Entry>,
  sv: sv as Record<string, Entry>,
}

export function getEventFaqEntry(locale: AppLocale, key: EventFaqKey): Entry {
  const pack = packs[locale] || packs.en
  return pack[key] || (packs.bg as Record<string, Entry>)[key]
}
